//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import skuEditor from '@/views/common-components/sku-editor.vue';
import fileUploader from '@/views/common-components/file-uploader.vue';

export default {
    name: 'goodInfo',
    components: {
        skuEditor,
        fileUploader
    },
    data() {
        const vm = this;
        return {
            goodId: 0,
            visible: false,
            loading: false,
            imageUrl: '',
            logoUrl: '',
            goodImageList: [],
            spec: {},
            specData: [],
            specificationList: [],
            goodGroupName: '',
            specEditableColumns: [{
                key: 'linePrice',
                title: '划线价'
            },
                {
                    key: 'price',
                    title: '价格'
                },
                {
                    key: 'inventory',
                    title: '库存'
                }
            ],
            goodType: 'GoodLogo',
            goodPictureType: 'GoodPicture',
            describeType: 'good.describe',
            giDescribe: {},
            albumColumns: [{
                key: 'name',
                title: '名称'
            },
                // {
                //     key: 'businessType',
                //     title: '租户类型'
                // },
                {
                    key: 'actions',
                    title: '操作',
                    width: 170,
                    align: 'center',
                    render(h, params) {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            on: {
                                click: function() {
                                    vm.editAlbum(row);
                                }
                            }
                        }, '编辑'));
                        actions.push(h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            style: {
                                marginLeft: '5px'
                            },
                            on: {
                                click() {
                                    vm.delAlbum(row);
                                }
                            }
                        }, '删除'));
                        return h('div', actions);
                    }
                }
            ]
        };
    },
    methods: {
        getGood() {
            this.loading = true;
            this.$store.dispatch({
                type: 'good/getGoodById',
                id: this.goodId
            }).then(() => {

            }).finally(() => {
                this.loading = false;
            });
        },
        // getGoodGroupList() {
        //     this.$store.dispatch({
        //         type: 'good/getGoodGroupList'
        //     }).then(() => {
        //         let groupList = this.$store.state.good.goodGroupList;
        //         if (this.good.goodGroupIds != undefined) {
        //             this.good.goodGroupIds.forEach(gpId => {
        //                 groupList.forEach(gp => {
        //                     if (gp.id == gpId) {
        //                         if (this.goodGroupName == '') {
        //                             this.goodGroupName = gp.groupName;
        //                         } else {
        //                             this.goodGroupName = gp.groupName + ',' + this.goodGroupName;
        //                         }
        //                         console.log(this.goodGroupName);
        //                     }
        //                 });
        //             });
        //         }
        //
        //     }).finally(() => {
        //     });
        // },
        getGoodSpecificationList() {
            this.loading = true;
            this.spec = {};
            var targetSpec = {};
            abp.ajax.get('/api/services/app/GoodSpecification/GetGoodSpecifiction?goodId=' + this.goodId).then((
                resp) => {
                var gs = resp.data.result;
                gs.goodAttributes.map((item, index) => {
                    var children = item.goodAttributeDetials.map((child, index) => {
                        return {
                            id: child.id,
                            parentId: item.id,
                            text: child.name
                        };
                    });
                    targetSpec[item.name] = children;
                });

                this.spec = targetSpec;
                this.specData = gs.goodSpecifications.map((item, index) => {
                    return {
                        id: item.goodAttributeDetailId,
                        linePrice: item.linePrice,
                        price: item.price,
                        inventory: item.inventory
                    };
                });

                console.log(this.specData);
            }).finally(() => {
                this.loading = false;
            });
        },
        getGraphicInformation(businessType) {
            this.loading = true;
            abp.ajax.get('/api/services/app/GraphicInformation/GetGraphicInformationByBusiness?businessId=' +
                this.goodId + '&businessType=' + businessType)
                .then((
                    resp) => {
                    if (resp.data.result != null) {
                        this.giDescribe = resp.data.result;
                    }
                }).finally(() => {
                this.loading = false;
            });
        },
        pageChangeAlbum(page) {
            this.$store.commit('album/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChangeAlbum(pageSize) {
            this.$store.commit('album/setPageSize', pageSize);
            this.getPage();
        },
        // getPageAlbum() {
        //     this.loading = true;
        //     this.$store.dispatch({
        //         type: 'album/getAlbumAll',
        //         data: {
        //             businessId: this.goodId,
        //             businessType: 'good'
        //         }
        //     }).finally(() => {
        //         this.loading = false;
        //     });
        // },
        editAlbum(album) {
            let parames = {
                id: album.id,
                businessId: album.businessId,
                businessType: album.businessType
            };
            this.$router.push({
                path: '/albumsEdit/' + JSON.stringify(parames)
            });
        },
        delAlbum(album) {
            this.$Modal.confirm({
                title: '删除确认',
                content: '您确定要删除' + album.name + '吗？',
                onOk: () => {
                    this.$store.dispatch({
                        type: 'album/delAlbum',
                        id: album.id
                    }).then(() => {
                        this.$Notice.success({
                            duration: 3,
                            title: album.name + '已删除'
                        });
                        this.getPage();
                    });
                },
                onCancel: () => {
                }
            });
        }
    },
    created() {
        console.log('商品详情');
        this.goodId = parseInt(this.$route.params.id || 0);
        this.getGood();
        this.getGoodSpecificationList();
        // this.getGraphicInformation(this.describeType);
        // this.getPageAlbum();
        // this.getGoodGroupList();
    },
    computed: {
        good() {
            return this.$store.state.good.goodInfo;
        },
        // albums() {
        //     return this.$store.state.album.albums;
        // },
        totalCountAlbum() {
            return this.$store.state.album.totalCount;
        },
        currentPageAlbum() {
            return this.$store.state.album.currentPage;
        },
        pageSizeAlbum() {
            return this.$store.state.album.pageSize;
        }
    },
    mounted() {
    },
    watch: {
        // $route: {
        //     handler: function (val, oldVal) {
        //         this.goodId = parseInt(this.$route.params.id || 0);
        //         if (this.goodId != 0) {
        //             this.getGood();
        //             this.getGoodSpecificationList();
        //             this.getGraphicInformation(this.describeType);
        //         }
        //     },
        //     deep: true
        // }
    }
};
